import React, { Suspense, useEffect, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { BrowserRouter, Router } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import { DoconToast, DoconLoader } from '@docon/docon-ui-library';
import DownloadContainer from './DownloadContainer';
import store, { history } from 'redux/store';
import { getStores } from 'redux/reducer/store';
import { updateAuthState } from 'redux/reducer/auth';
import { getAllCity, getAllZones } from 'redux/reducer/app';
import { axiosInstance, headerKey } from 'helper/axiosHelper';
import {
  bgColor,
  appTheme,
} from 'utilities/colorConfig';
import { storageService } from 'services';

const Routes = React.lazy(() => import('./Routes'));

const BASENAME = process.env.REACT_APP_BASENAME || '/';

const Toast = styled(DoconToast)`
  font-size: 14px;
  line-height: 18px;
`;

function App() {
  const dispatch = useDispatch();

  const { accessToken, authUser } = useSelector((state) => state.auth);
  const { zones } = useSelector((state) => state.app);
  const [isMount, setIsMount] = useState(false);

  useEffect(() => {
    Promise.all([
      storageService.get(storageService.ACCESS_TOKEN),
      storageService.get(storageService.REFRESH_TOKEN),
      storageService.get(storageService.USER),
    ]).then(function ([accessToken, refreshToken, user]) {
      const authUser = JSON.parse(user as string);
      if (accessToken && !isEmpty(authUser)) {
        authUser.refreshToken = refreshToken;
        dispatch(updateAuthState({ accessToken, authUser }));
      }

      setIsMount(true);
    });
  }, []);

  useEffect(() => {
    if (accessToken) {
      storageService.set(storageService.ACCESS_TOKEN, accessToken);
      storageService.set(storageService.REFRESH_TOKEN, authUser?.refreshToken);
      storageService.set(storageService.USER, JSON.stringify(authUser));
      axiosInstance.setHeader(headerKey.Authorization, `Bearer ${accessToken}`);
      if (!isEmpty(zones)) return;

      const companyId = authUser?.companyId;
      dispatch(getAllCity({ companyId }));
      dispatch(getAllZones({ companyId }));
      dispatch(getStores({ companyId }));
    }
  }, [accessToken]);

  return (
    <>
      <Toast
        hideProgressBar
        theme='colored'
        position='top-center'
        autoClose={3000}
      />

      <DownloadContainer />

      <Router history={history}>
        <BrowserRouter basename={BASENAME}>
          {
            isMount ? <Routes /> : <DoconLoader height='100vh' iconSize={50} />
          }
        </BrowserRouter>
      </Router>
    </>
  );
}

function AppWrapper() {

  return (
    <Provider store={store}>
      <ThemeProvider theme={appTheme}>
        <Suspense fallback={<DoconLoader bg={bgColor.base} height='100vh' />}>
          <App />
        </Suspense>
      </ThemeProvider>
    </Provider>
  );
}

export default AppWrapper;